import { Text } from "@/elements"
import { MarkerPinIcon } from "@/icons/solid"
import clsx from "clsx"

interface Props {
  location: string | undefined
  className?: string
  iconClassName?: string
  textClassName?: string
  onClick?: () => void
}

export const LocationDisplay: React.FC<Props> = ({ location, iconClassName, textClassName, className, onClick }) => {
  if (!location) return null
  return (
    <div className={clsx("flex flex-grow-0 flex-row items-center justify-start", className)} onClick={onClick}>
      <MarkerPinIcon height={18} width={18} className={clsx("mr-1 stroke-fg-1", iconClassName)} />
      <Text variant="caption" className={textClassName}>
        {location}
      </Text>
    </div>
  )
}
